import { RootState } from "../../utils/types"

export const requestsSelector = (state: RootState) =>
  state.requests

